import { render } from "./PortfolioDetailsPage.vue?vue&type=template&id=c6979c72"
import script from "./PortfolioDetailsPage.vue?vue&type=script&lang=js"
export * from "./PortfolioDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__